import { FilterProps } from '@/components/Filter/types';
import { GroupedOptions, NewFilterOption } from '@/components/FilterNew/types';
import { GroupAdditionMethodEnum, Maybe } from '@/types/schema';

import { filterBottomSheetStyles, filterPaperStyles } from '../styles';

export const MENU_LIST_OVERRIDES: FilterProps['overrides'] = {
  className: filterPaperStyles,
  classes: {
    BottomSheet: { root: filterBottomSheetStyles },
  },
};

export function getEntityFilterGroups<T>(
  data: Maybe<T[]> | undefined,
  getEntityFilterOption: (d: T) => NewFilterOption,
): GroupedOptions[] {
  return data?.length ? [{ id: 'ENTITY_FILTER', options: data.map(getEntityFilterOption) }] : [];
}

export const adaptGroupFilter = (groupFilter?: string[]) => {
  if (!groupFilter?.length) {
    return undefined;
  }

  return {
    groupIds: groupFilter,
    groupAdditionMethod: GroupAdditionMethodEnum.All,
  };
};
